import { render, staticRenderFns } from "./ElmcoFabrication.vue?vue&type=template&id=09574717&scoped=true"
import script from "./ElmcoFabrication.vue?vue&type=script&lang=js"
export * from "./ElmcoFabrication.vue?vue&type=script&lang=js"
import style0 from "./ElmcoFabrication.vue?vue&type=style&index=0&id=09574717&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09574717",
  null
  
)

export default component.exports